// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.curator-details-page {
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
}

/* Базовый стиль для всех скроллбаров */
* {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

/* WebKit (Chrome, Safari, Edge) - единый стиль */
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

*::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
}

*::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

/* Шапка */
.attendance-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.header-left-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.backs-button {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: 44px;
  height: 44px;
}

.backs-button:hover {
  background: #f8fafc;
  border-color: #002FA7;
  transform: translateY(-2px);
}

.backs-button img {
  width: 24px;
  height: 24px;
}

/* Информация о группе */
.curator-group-info-header {
  background: linear-gradient(135deg, #002FA7 0%, #1a4ad1 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  color: white;
}

.group-info-main h1 {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
}

.group-specialty {
  margin: 0 0 16px 0;
  font-size: 16px;
  opacity: 0.9;
}

.group-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stat-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

/* Секция старосты */
.curator-details-monitor-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.curator-details-monitor-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.curator-details-monitor-rows {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.curator-details-monitor-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid #e2e8f0;
  gap: 24px;
  min-height: 48px;
}

.curator-details-monitor-row:last-child {
  border-bottom: none;
}

/* Стиль для пустого состояния старосты */
.curator-monitor-empty {
  cursor: pointer;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.3s ease;
  background: #f8fafc;
}

.curator-monitor-empty:hover {
  border-color: #002FA7;
  background: #f0f4ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.curator-details-monitor-name.empty-monitor {
  color: #64748b;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.curator-details-monitor-name.empty-monitor:hover {
  color: #002FA7;
}

.monitor-placeholder-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: #002FA7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.curator-details-monitor-name.empty-monitor::after {
  display: none;
}

.curator-details-monitor-name.empty-monitor:hover::after {
  display: none;
}

/* Левая колонка - имена старост */
.curator-details-monitor-names {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 280px;
}

.curator-details-monitor-name {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
  letter-spacing: -0.2px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  display: inline-block;
  width: fit-content;
  flex-shrink: 0;
}

/* Подчеркивание под ФИО */
.curator-details-monitor-name::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #002FA7, #5986f7);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.curator-details-monitor-name:hover::after {
  width: 20%;
}

.curator-details-monitor-name.clickable {
  padding-right: 28px;
  position: relative;
}

.curator-details-monitor-name.clickable::before {
  content: '✎';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #64748b;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.curator-details-monitor-name.clickable:hover::before {
  opacity: 1;
  color: #1b4ac0;
}

.curator-details-monitor-name:hover {
  color: #1b4ac0;
  transform: translateY(-1px);
}

/* Правая колонка - контакты */
.curator-details-monitor-contacts {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}

.curator-details-monitor-contact-item {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
}

.monitor-contact-details {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
}

.monitor-contact-details span {
  color: #3a4b63;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
  padding: 6px 14px;
  border-radius: 30px;
  border: 1px solid #e9ecf0;
  transition: all 0.2s ease;
  font-size: 13px;
  white-space: nowrap; 
}

.monitor-contact-details span:hover {
  background: #f0f4ff;
  border-color: #d0d9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.08);
}

.meta-label {
  color: #64748b;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .curator-details-monitor-info {
    flex-direction: column;
    gap: 24px;
  }
  
  .curator-details-monitor-contacts {
    width: 100%;
  }
  
  .curator-details-monitor-contact-item {
    justify-content: flex-start;
  }
  
  .monitor-contact-details {
    justify-content: flex-start;
    width: 100%;
  }
  
  .monitor-contact-details span {
    flex: 1 1;
    justify-content: center;
  }
}

/* Таблица студентов */
.curator-details-students-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
  overflow-x: auto;
}

.curator-details-students-section h3 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.curator-details-students-section h3 img {
  width: 20px;
  height: 20px;
}

.curator-details-table-container {
  width: 100%;
  overflow-x: auto;
}

.curator-details-table {
  width: 100%;
  min-width: 650px;
  border-collapse: collapse;
}

.curator-details-table th {
  background: #f8fafc;
  color: #002c9c;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 8px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.curator-details-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 13px;
}

.curator-details-table tr.current-monitor {
  background: rgba(0, 47, 167, 0.05);
}

.curator-details-table tr.current-monitor td.curator-details-col-name {
  font-weight: 600;
  color: #002FA7;
}

.monitor-badge {
  display: inline-block;
  background: #002FA7;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 8px;
}

.curator-details-col-number {
  width: 40px;
  text-align: center;
  color: #64748b;
}

.curator-details-col-name {
  max-width: 250px;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.curator-details-col-name:hover {
  white-space: normal;
  overflow: visible;
  position: relative;
  z-index: 10000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 10px 8px;
}

.curator-details-col-attendance {
  width: 80px;
  text-align: center;
}

.curator-details-col-average {
  width: 80px;
  text-align: center;
  font-weight: 600;
}

.curator-details-col-actions {
  width: 60px;
  text-align: center;
}

.curator-details-attendance-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  color: white;
  font-weight: 600;
  min-width: 40px;
  text-align: center;
}

.curator-details-grade-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  color: white;
  font-weight: 600;
  min-width: 40px;
  text-align: center;
}

.curator-details-action-btn {
  background: white;
  border: 1px solid #002FA7;
  border-radius: 6px;
  cursor: pointer;
  padding: 6px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.curator-details-action-btn:hover {
  background: #f0f4ff;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.15);
}

.curator-details-action-btn img {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(2349%) hue-rotate(217deg) brightness(94%) contrast(107%);
}

/* Социальный портрет */
.curator-details-social-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.social-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.social-section-header h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #002FA7;
  font-size: 16px;
  font-weight: 600;
}

.section-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(2349%) hue-rotate(217deg) brightness(94%) contrast(107%);
}

.curator-details-social-edit-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #002FA7;
  border-radius: 8px;
  color: #002FA7;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-details-social-edit-btn:hover {
  background: #f0f4ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.curator-details-social-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}

.curator-details-social-card {
  background: #f8fafc;
  border-radius: 10px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.curator-details-social-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.curator-details-social-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.curator-details-social-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 14px;
  font-weight: 700;
}

.curator-details-social-count {
  background: #e2e8f0;
  color: #002FA7;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.curator-details-social-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.curator-details-social-list li {
  padding: 5px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  text-indent: 0;
}

.curator-details-social-list li:last-child {
  border-bottom: none;
}

.curator-details-social-copy-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
  width: 100%;
  justify-content: center;
}

.curator-details-social-copy-btn:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
}

.curator-details-social-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 30px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px dashed #e2e8f0;
}

.curator-details-social-fill-btn {
  margin-top: 12px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #002FA7;
  border-radius: 8px;
  color: #002FA7;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-details-social-fill-btn:hover {
  background: #f0f4ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

/* Модальные окна */
.curator-details-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  backdrop-filter: blur(4px);
}

.curator-details-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.curator-details-modal.monitor-selection-modal {
  max-width: 640px;
  width: 92%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px;
}

.monitor-search-section {
  flex-shrink: 0;
  padding: 0 22px;
}

.curator-details-modal.monitor-selection-modal .curator-details-modal-content {
  padding: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.curator-details-modal.monitor-selection-modal .curator-details-students-list {
  overflow-y: auto;
  flex: 1 1;
  padding: 0 22px 14px;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.curator-details-modal.large {
  max-width: 640px;
  width: 92%;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px;
}

.curator-details-modal.monitor-modal {
  max-width: 850px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Шапка — фиксированная высота */
.curator-details-modal.large .curator-details-modal-header {
  padding: 14px 22px;
  flex-shrink: 0;
}

/* Футер — фиксированная высота */
.curator-details-modal.large .curator-details-modal-actions {
  padding: 12px 22px;
  flex-shrink: 0;
  gap: 10px;
}

/* Контент — гибкая колонка, скролл только внутри списка */
.curator-details-modal.large .curator-details-modal-content {
  padding: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.curator-details-modal.large .curator-details-search-box {
  margin: 12px 22px 10px;
  flex-shrink: 0;
  position: relative;
}

.curator-details-modal.large .curator-details-selection-info {
  margin: 0 22px 10px;
  padding: 9px 14px;
  min-height: 42px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
}

.curator-details-modal.large .curator-details-students-list {
  overflow-y: auto;
  flex: 1 1;
  padding: 0 22px 14px;
  gap: 6px;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}


/* Чекбокс — компактный */
.curator-details-modal.large .checkbox-custom {
  width: 18px;
  height: 18px;
  border-radius: 4px;
}

/* Текст — плотнее */
.curator-details-modal.large .curator-details-student-name {
  font-size: 14px;
  line-height: 1.3;
}
.curator-details-modal.large .curator-details-student-details {
  font-size: 11px;
  margin-top: 1px;
}

/* Кнопка "Очистить все" — компактнее */
.curator-details-modal.large .clear-selection-btn {
  padding: 3px 10px;
  font-size: 12px;
  border-radius: 4px;
}

.curator-details-modal-content.social-portrait-content {
  padding: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.curator-details-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  position: relative;
}

.curator-details-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.curator-details-modal-header p {
  margin: 4px 0 0 0;
  font-size: 13px;
  opacity: 0.9;
  color: white;
}

.curator-details-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.curator-details-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.curator-details-modal-content {
  padding: 20px;
}

/* Поиск в модальном окне */
.curator-details-search-box {
  position: relative;
  margin-bottom: 16px;
  margin-top: 10px;
}

.curator-details-search-box img {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
}

.curator-details-search-input {
  width: 100%;
  padding: 10px 12px 10px 38px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;
}

.curator-details-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.curator-details-search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #64748b;
  font-size: 18px;
  cursor: pointer;
  padding: 0 5px;
}

.curator-details-search-clear:hover {
  color: #ef4444;
}

/* Список студентов для смены старосты */
.curator-details-students-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 350px;
  overflow-y: auto;
}

.curator-details-student-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-details-student-option:hover {
  border-color: #002FA7;
  background: white;
}

.curator-details-student-option.current {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.05);
}

.curator-details-student-info {
  flex: 1 1;
}

.curator-details-student-name {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  font-size: 14px;
}

.curator-details-student-details {
  font-size: 12px;
  color: #64748b;
}

.curator-details-current-badge {
  background: #002FA7;
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.curator-details-empty-search {
  text-align: center;
  padding: 24px;
  color: #64748b;
  font-style: italic;
}

/* Формы */
.curator-details-form-group {
  margin-bottom: 16px;
}

.curator-details-form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}

.curator-details-input,
.curator-details-select {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;
}

.curator-details-input:focus,
.curator-details-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.readonly-value {
  padding: 8px 12px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  font-size: 14px;
}

.curator-details-form-hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

/* Кнопки модальных окон */
.curator-details-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 12px 12px;
}

.button-secondary {
  padding: 8px 16px;
  background: white;
  color: #1e293b;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.button-secondary:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.button-primary {
  padding: 10px 20px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.button-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

/* Информационная иконка */
.info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.info-icon-text {
  font-weight: 700;
  font-size: 16px;
  color: #002FA7;
}

.info-icon-btn:hover .info-tooltip,
.info-icon-btn:focus-within .info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
}

.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(10px);
  background: white;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 20px;
  width: 320px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.info-tooltip-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}

.info-section {
  margin-top: 16px;
}

.info-section h4 {
  margin: 0 0 12px 0;
  color: #002FA7;
  font-size: 14px;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.steps {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.steps-number {
  width: 24px;
  height: 24px;
  background: #002FA7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.header-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  height: 44px;
}

.header-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.pc-refresh-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.curator-details-modal.social-data-modal {
  max-width: 900px;
  width: 92%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.two-columns-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding: 0 4px;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.social-categories-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 450px;
  overflow-y: auto;
  padding-right: 8px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.social-category-item {
  background: #f0f4ff;
  border: 1px solid #d0d9ff;
  border-radius: 10px;
  padding: 12px;
  transition: all 0.2s ease;
}

.social-category-item.selected {
  background: #e8eeff;
  border-color: #002FA7;
}

.social-category-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.social-category-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  accent-color: #002FA7;
  cursor: pointer;
  position: relative;
  top: 3px;
  margin-right: 10px;
}

.social-category-name {
  font-size: 14px;
  font-weight: 500;
}

.extra-fields {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #d0d9ff;
}

.extra-field {
  margin-bottom: 10px;
}

.extra-field:last-child {
  margin-bottom: 0;
}

.extra-field label {
  font-size: 12px;
  color: #475569;
  margin-bottom: 4px;
  display: block;
}

/* Подсказка в социальном портрете */
.social-portrait-hint {
  margin-top: 20px;
  padding: 14px 18px;
  border-left: 4px solid #002FA7;
  border-radius: 10px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.hint-text {
  font-size: 13px;
  color: #002FA7;
  line-height: 1.5;
}

.hint-text strong {
  color: #002FA7;
}

/* Стили для степпера социального портрета */
.social-portrait-stepper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.stepper-header {
  padding: 16px 20px 12px;
  border-bottom: 2px solid #e2e8f0;
  flex-shrink: 0;
  background: white;
}

.stepper-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 0 15px;
}

.stepper-steps::before {
  content: '';
  position: absolute;
  top: 18px;
  left: 35px;
  right: 35px;
  height: 2px;
  background: #e2e8f0;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1 1;
}

.step .step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 6px;
  transition: all 0.3s;
  font-size: 14px;
}

.step.active .step-number {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-color: #002FA7;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
}

.step-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-align: center;
  max-width: 90px;
}

.step.active .step-label {
  color: #002FA7;
}

.stepper-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* Категории в шаге 1 */
.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
}

.category-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.category-card:hover {
  border-color: #002FA7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.category-card.selected {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.03);
}

.category-card-content {
  flex: 1 1;
}

.category-card-content h5 {
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
  margin: 0;
}

.category-card-check {
  width: 24px;
  height: 24px;
  background: #002FA7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

/* Двухколоночный макет для шага 2 */
.two-column-layout {
  display: flex;
  gap: 20px;
  height: 400px;
  overflow: hidden;
}

.categories-sidebar {
  width: 250px;
  flex-shrink: 0;
  background: #f8fafc;
  border-radius: 10px;
  padding: 12px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
}

.categories-sidebar h4 {
  margin: 0 0 12px 0;
  color: #002FA7;
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 2px solid #e2e8f0;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.category-sidebar-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.category-sidebar-item:hover {
  border-color: #002FA7;
  transform: translateX(2px);
}

.category-sidebar-item.active {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.05);
  border-left-width: 3px;
}

.category-sidebar-name {
  font-size: 12px;
  font-weight: 500;
  color: #1e293b;
}

.category-sidebar-count {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 12px;
}

.students-sidebar {
  flex: 1 1;
  background: white;
  border-radius: 10px;
  padding: 12px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}


.current-category-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.current-category-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 16px;
  font-weight: 700;
}

.students-selection-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.selection-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.search-student {
  flex: 1 1;
  position: relative;
}

.search-student input {
  width: 100%;
  padding: 8px 8px 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  height: 34px;
  box-sizing: border-box;
}

.search-student input:focus {
  outline: none;
  border-color: #002FA7;
}

.search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
}

.btn-select-all {
  padding: 0 10px;
  height: 34px;
  background: white;
  color: #475569;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.btn-select-all:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.students-list {
  max-height: 160px;
  overflow-y: auto;
  padding: 6px;
  background: #f8fafc;
  border-radius: 6px;
}

.students-list.full-height {
  flex: 1 1;
  max-height: none;
}

.student-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: white;
  border-radius: 6px;
  margin-bottom: 4px;
  cursor: pointer;
  border: 1px solid #e2e8f0;
}

.student-checkbox:last-child {
  margin-bottom: 0;
}

.student-checkbox:hover {
  border-color: #002FA7;
}

.student-checkbox.checked {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.05);
}

.student-checkbox input[type="checkbox"] {
  display: none;
}

.student-checkbox .checkbox-custom {
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 4px;
  display: inline-block;
  flex-shrink: 0;
}

.student-checkbox.checked .checkbox-custom {
  background: #002FA7;
  border-color: #002FA7;
  position: relative;
}

.student-checkbox.checked .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 10px;
}

.student-name {
  flex: 1 1;
  color: #1e293b;
  font-size: 12px;
  font-weight: 500;
}

.no-results {
  text-align: center;
  padding: 16px;
  color: #94a3b8;
  font-size: 12px;
}

.stepper-footer {
  flex-shrink: 0;
  padding: 12px 20px 16px;
  border-top: 2px solid #e2e8f0;
  background: white;
  border-radius: 0 0 12px 12px;
}

.stepper-progress {
  margin-bottom: 12px;
}

.stepper-progress .progress-bar {
  height: 5px;
  background: #f8fafc;
  border-radius: 3px;
  overflow: hidden;
}

.stepper-progress .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #002FA7, #5986f7);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.stepper-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .two-column-layout {
    flex-direction: column;
    height: auto;
  }
  
  .categories-sidebar {
    width: 100%;
    max-height: 200px;
  }
  
  .selection-controls {
    flex-direction: column;
  }
  
  .btn-select-all {
    width: 100%;
    justify-content: center;
  }
  
  .curator-details-monitor-meta {
    flex-direction: column;
  }
  
  .curator-details-monitor-name {
    min-width: auto;
  }
  
  .stepper-steps::before {
    display: none;
  }
  
  .step {
    flex-direction: row;
    gap: 12px;
  }
  
  .step .step-number {
    margin-bottom: 0;
  }
  
  .step-label {
    text-align: left;
    max-width: none;
  }
  
  .categories-grid {
    grid-template-columns: 1fr;
  }
  
  .curator-details-table {
    min-width: 500px;
  }
  
  .curator-details-col-name {
    max-width: 150px;
    min-width: 120px;
  }
}

.social-categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.social-categories-grid.large {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  max-height: 400px;
  overflow-y: auto;
  padding: 4px;
}

/* Карточка социальной категории */
.social-category-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.social-category-card:hover {
  border-color: #002FA7;
  background: #f0f4ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.social-category-card.selected {
  border-color: #002FA7;
  background: linear-gradient(135deg, rgba(0, 47, 167, 0.05), rgba(89, 134, 247, 0.05));
}

/* Чекбокс для категории */
.category-checkbox,
.category-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background: white;
}

.social-category-card.selected .category-checkbox,
.social-category-card.selected .category-icon {
  background: #002FA7;
  border-color: #002FA7;
  color: white;
}

.category-checkbox span,
.category-icon span {
  font-size: 14px;
  font-weight: bold;
}

.category-name {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  flex: 1 1;
}

.category-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.curator-details-student-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-details-student-option:hover {
  border-color: #002FA7;
  background: white;
  transform: translateX(4px);
}

.curator-details-student-option.selected {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.05);
}

.curator-details-student-checkbox {
  flex-shrink: 0;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: white;
}

.checkbox-custom.checked {
  background: #002FA7;
  border-color: #002FA7;
  color: white;
}

.checkbox-custom.checked span {
  font-size: 12px;
  font-weight: bold;
}

.readonly-value {
  padding: 10px 12px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  font-size: 14px;
  cursor: not-allowed;
  width: 100%;
  box-sizing: border-box;
}


.curator-details-monitor-meta {
  display: flex;
  gap: 16px;
  font-size: 14px;
  color: #4f5b66;
  flex-wrap: wrap;
  align-items: center;
}

.curator-details-monitor-meta span {
  color: #3a4b63;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  background: #f8fafc;
  padding: 8px 16px;
  border-radius: 30px;
  border: 1px solid #e9ecf0;
  transition: all 0.2s ease;
}

.curator-details-monitor-meta span:hover {
  background: #f0f4ff;
  border-color: #d0d9ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.08);
}

.meta-label {
  color: #64748b;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.curator-details-modal-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px;
}

.curator-details-form-group {
  margin-bottom: 20px;
}

.curator-details-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}

.curator-details-input,
.curator-details-select {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;
}

.curator-details-input:focus,
.curator-details-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.curator-details-form-hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .social-categories-grid {
    grid-template-columns: 1fr;
  }
  
  .curator-details-monitor-info {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .curator-details-monitor-meta {
    flex-direction: column;
    width: 100%;
  }
  
  .curator-details-monitor-meta span {
    width: 100%;
    justify-content: center;
  }
  
  .curator-details-modal {
    width: 95%;
    margin: 16px;
  }
}

/* Стили для 1 шага социального портрета */
.social-portrait-step1 {
  animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 8px;
}

.category-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  position: relative;
  overflow: hidden;
}

.category-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #002FA7, #5986f7);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.category-card:hover {
  border-color: #002FA7;
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 47, 167, 0.15);
}

.category-card:hover::before {
  opacity: 1;
}

.category-card.selected {
  border-color: #002FA7;
  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03), rgba(89, 134, 247, 0.03));
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 47, 167, 0.12);
}

.category-card-content {
  flex: 1 1;
}

.category-card-content h5 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  transition: color 0.2s ease;
}

.category-card.selected .category-card-content h5 {
  color: #002FA7;
}

.category-card-description {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

.category-card-check {
  width: 28px;
  height: 28px;
  background: white;
  border: 2px solid #cbd5e1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.category-card.selected .category-card-check {
  background: #002FA7;
  border-color: #002FA7;
  transform: scale(1.1);
}

.category-card-check span {
  color: white;
  font-size: 14px;
  font-weight: bold;
}

/* Анимация для выбранных карточек */
@keyframes selectPop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.category-card.selected {
  animation: selectPop 0.3s ease-out;
}

/* Шапка степпера с улучшенным дизайном */
.stepper-header {
  padding: 20px 24px 16px;
  border-bottom: 2px solid #e2e8f0;
  flex-shrink: 0;
  background: linear-gradient(to bottom, #ffffff, #fafbfc);
}

.stepper-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 0 20px;
}

.stepper-steps::before {
  content: '';
  position: absolute;
  top: 18px;
  left: 50px;
  right: 50px;
  height: 3px;
  background: linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%);
  z-index: 1;
  border-radius: 3px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1 1;
  cursor: default;
}

.step .step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 3px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  font-size: 16px;
  position: relative;
  z-index: 2;
}

.step.active .step-number {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-color: #002FA7;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);
  transform: scale(1.05);
}

.step.completed .step-number {
  background: #10b981;
  border-color: #10b981;
  color: white;
}

.step.completed .step-number::after {
  content: '✓';
  font-size: 14px;
}

.step-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-align: center;
  max-width: 120px;
  letter-spacing: 0.3px;
}

.step.active .step-label {
  color: #002FA7;
  font-weight: 700;
}

/* Мультистрочное отображение старост */
.curator-headman-value {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.curator-monitor-name-line {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  line-height: 1.3;
}

.curator-detail-value-multiline {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.curator-detail-value-multiline div {
  font-size: 13px;
  color: #002FA7;
  font-weight: 600;
}

/* Стили для выбора нескольких старост */
.curator-details-selection-info {
  margin: 0 0 12px 0;
  padding: 8px 14px;
  background: #f8fafc;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selection-count {
  font-size: 13px;
  color: #475569;
}

.selection-count strong {
  color: #002FA7;
  font-size: 16px;
}

.clear-selection-btn {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.clear-selection-btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

.curator-details-student-option.selected {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.05);
}

.curator-details-student-checkbox {
  flex-shrink: 0;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: white;
  cursor: pointer;
}

.checkbox-custom.checked {
  background: #002FA7;
  border-color: #002FA7;
}

.checkbox-custom.checked span {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.curator-details-student-option .curator-details-student-info {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/th-components/CuratorGroupDetails.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;AACF;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6HAA6H;AAC/H;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6HAA6H;AAC/H;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,oBAAoB;EACpB,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;;AAGA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;;AAGA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,qFAAqF;AACvF;;AAEA,0BAA0B;AAC1B;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qFAAqF;EACrF,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,4DAA4D;EAC5D,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".curator-details-page {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Базовый стиль для всех скроллбаров */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n/* WebKit (Chrome, Safari, Edge) - единый стиль */\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 3px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n/* Шапка */\n.attendance-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.header-left-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.backs-button {\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  width: 44px;\n  height: 44px;\n}\n\n.backs-button:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  transform: translateY(-2px);\n}\n\n.backs-button img {\n  width: 24px;\n  height: 24px;\n}\n\n/* Информация о группе */\n.curator-group-info-header {\n  background: linear-gradient(135deg, #002FA7 0%, #1a4ad1 100%);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  color: white;\n}\n\n.group-info-main h1 {\n  margin: 0 0 8px 0;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.group-specialty {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  opacity: 0.9;\n}\n\n.group-stats {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.stat-badge {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Секция старосты */\n.curator-details-monitor-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.curator-details-monitor-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n.curator-details-monitor-rows {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.curator-details-monitor-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 0;\n  border-bottom: 1px solid #e2e8f0;\n  gap: 24px;\n  min-height: 48px;\n}\n\n.curator-details-monitor-row:last-child {\n  border-bottom: none;\n}\n\n/* Стиль для пустого состояния старосты */\n.curator-monitor-empty {\n  cursor: pointer;\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.3s ease;\n  background: #f8fafc;\n}\n\n.curator-monitor-empty:hover {\n  border-color: #002FA7;\n  background: #f0f4ff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.curator-details-monitor-name.empty-monitor {\n  color: #64748b;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n}\n\n.curator-details-monitor-name.empty-monitor:hover {\n  color: #002FA7;\n}\n\n.monitor-placeholder-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: #002FA7;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.curator-details-monitor-name.empty-monitor::after {\n  display: none;\n}\n\n.curator-details-monitor-name.empty-monitor:hover::after {\n  display: none;\n}\n\n/* Левая колонка - имена старост */\n.curator-details-monitor-names {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 280px;\n}\n\n.curator-details-monitor-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n  letter-spacing: -0.2px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  display: inline-block;\n  width: fit-content;\n  flex-shrink: 0;\n}\n\n/* Подчеркивание под ФИО */\n.curator-details-monitor-name::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #002FA7, #5986f7);\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.curator-details-monitor-name:hover::after {\n  width: 20%;\n}\n\n.curator-details-monitor-name.clickable {\n  padding-right: 28px;\n  position: relative;\n}\n\n.curator-details-monitor-name.clickable::before {\n  content: '✎';\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: #64748b;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.curator-details-monitor-name.clickable:hover::before {\n  opacity: 1;\n  color: #1b4ac0;\n}\n\n.curator-details-monitor-name:hover {\n  color: #1b4ac0;\n  transform: translateY(-1px);\n}\n\n/* Правая колонка - контакты */\n.curator-details-monitor-contacts {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n\n.curator-details-monitor-contact-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0;\n}\n\n.monitor-contact-details {\n  display: flex;\n  gap: 16px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.monitor-contact-details span {\n  color: #3a4b63;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #f8fafc;\n  padding: 6px 14px;\n  border-radius: 30px;\n  border: 1px solid #e9ecf0;\n  transition: all 0.2s ease;\n  font-size: 13px;\n  white-space: nowrap; \n}\n\n.monitor-contact-details span:hover {\n  background: #f0f4ff;\n  border-color: #d0d9ff;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.08);\n}\n\n.meta-label {\n  color: #64748b;\n  font-weight: 500;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .curator-details-monitor-info {\n    flex-direction: column;\n    gap: 24px;\n  }\n  \n  .curator-details-monitor-contacts {\n    width: 100%;\n  }\n  \n  .curator-details-monitor-contact-item {\n    justify-content: flex-start;\n  }\n  \n  .monitor-contact-details {\n    justify-content: flex-start;\n    width: 100%;\n  }\n  \n  .monitor-contact-details span {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n/* Таблица студентов */\n.curator-details-students-section {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 24px;\n  overflow-x: auto;\n}\n\n.curator-details-students-section h3 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.curator-details-students-section h3 img {\n  width: 20px;\n  height: 20px;\n}\n\n.curator-details-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.curator-details-table {\n  width: 100%;\n  min-width: 650px;\n  border-collapse: collapse;\n}\n\n.curator-details-table th {\n  background: #f8fafc;\n  color: #002c9c;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 8px;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.curator-details-table td {\n  padding: 10px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.curator-details-table tr.current-monitor {\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.curator-details-table tr.current-monitor td.curator-details-col-name {\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.monitor-badge {\n  display: inline-block;\n  background: #002FA7;\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n  margin-left: 8px;\n}\n\n.curator-details-col-number {\n  width: 40px;\n  text-align: center;\n  color: #64748b;\n}\n\n.curator-details-col-name {\n  max-width: 250px;\n  min-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.curator-details-col-name:hover {\n  white-space: normal;\n  overflow: visible;\n  position: relative;\n  z-index: 10000;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border-radius: 4px;\n  padding: 10px 8px;\n}\n\n.curator-details-col-attendance {\n  width: 80px;\n  text-align: center;\n}\n\n.curator-details-col-average {\n  width: 80px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.curator-details-col-actions {\n  width: 60px;\n  text-align: center;\n}\n\n.curator-details-attendance-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  color: white;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: center;\n}\n\n.curator-details-grade-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  color: white;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: center;\n}\n\n.curator-details-action-btn {\n  background: white;\n  border: 1px solid #002FA7;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 6px;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.curator-details-action-btn:hover {\n  background: #f0f4ff;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.15);\n}\n\n.curator-details-action-btn img {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(2349%) hue-rotate(217deg) brightness(94%) contrast(107%);\n}\n\n/* Социальный портрет */\n.curator-details-social-section {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.social-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.social-section-header h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.section-icon {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(2349%) hue-rotate(217deg) brightness(94%) contrast(107%);\n}\n\n.curator-details-social-edit-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #002FA7;\n  border-radius: 8px;\n  color: #002FA7;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-details-social-edit-btn:hover {\n  background: #f0f4ff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.curator-details-social-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.curator-details-social-card {\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.curator-details-social-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.curator-details-social-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.curator-details-social-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.curator-details-social-count {\n  background: #e2e8f0;\n  color: #002FA7;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.curator-details-social-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.curator-details-social-list li {\n  padding: 5px 0;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 12px;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  text-indent: 0;\n}\n\n.curator-details-social-list li:last-child {\n  border-bottom: none;\n}\n\n.curator-details-social-copy-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  color: #64748b;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 8px;\n  width: 100%;\n  justify-content: center;\n}\n\n.curator-details-social-copy-btn:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.curator-details-social-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 30px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px dashed #e2e8f0;\n}\n\n.curator-details-social-fill-btn {\n  margin-top: 12px;\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #002FA7;\n  border-radius: 8px;\n  color: #002FA7;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-details-social-fill-btn:hover {\n  background: #f0f4ff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n/* Модальные окна */\n.curator-details-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999999;\n  backdrop-filter: blur(4px);\n}\n\n.curator-details-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n}\n\n.curator-details-modal.monitor-selection-modal {\n  max-width: 640px;\n  width: 92%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 14px;\n}\n\n.monitor-search-section {\n  flex-shrink: 0;\n  padding: 0 22px;\n}\n\n.curator-details-modal.monitor-selection-modal .curator-details-modal-content {\n  padding: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.curator-details-modal.monitor-selection-modal .curator-details-students-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 0 22px 14px;\n  min-height: 0;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.curator-details-modal.large {\n  max-width: 640px;\n  width: 92%;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 14px;\n}\n\n.curator-details-modal.monitor-modal {\n  max-width: 850px;\n  width: 90%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Шапка — фиксированная высота */\n.curator-details-modal.large .curator-details-modal-header {\n  padding: 14px 22px;\n  flex-shrink: 0;\n}\n\n/* Футер — фиксированная высота */\n.curator-details-modal.large .curator-details-modal-actions {\n  padding: 12px 22px;\n  flex-shrink: 0;\n  gap: 10px;\n}\n\n/* Контент — гибкая колонка, скролл только внутри списка */\n.curator-details-modal.large .curator-details-modal-content {\n  padding: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.curator-details-modal.large .curator-details-search-box {\n  margin: 12px 22px 10px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.curator-details-modal.large .curator-details-selection-info {\n  margin: 0 22px 10px;\n  padding: 9px 14px;\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  border-radius: 8px;\n}\n\n.curator-details-modal.large .curator-details-students-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 0 22px 14px;\n  gap: 6px;\n  min-height: 0;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n\n/* Чекбокс — компактный */\n.curator-details-modal.large .checkbox-custom {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n}\n\n/* Текст — плотнее */\n.curator-details-modal.large .curator-details-student-name {\n  font-size: 14px;\n  line-height: 1.3;\n}\n.curator-details-modal.large .curator-details-student-details {\n  font-size: 11px;\n  margin-top: 1px;\n}\n\n/* Кнопка \"Очистить все\" — компактнее */\n.curator-details-modal.large .clear-selection-btn {\n  padding: 3px 10px;\n  font-size: 12px;\n  border-radius: 4px;\n}\n\n.curator-details-modal-content.social-portrait-content {\n  padding: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n\n.curator-details-modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border-radius: 12px 12px 0 0;\n  position: relative;\n}\n\n.curator-details-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.curator-details-modal-header p {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  opacity: 0.9;\n  color: white;\n}\n\n.curator-details-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: white;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.curator-details-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.curator-details-modal-content {\n  padding: 20px;\n}\n\n/* Поиск в модальном окне */\n.curator-details-search-box {\n  position: relative;\n  margin-bottom: 16px;\n  margin-top: 10px;\n}\n\n.curator-details-search-box img {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n}\n\n.curator-details-search-input {\n  width: 100%;\n  padding: 10px 12px 10px 38px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.curator-details-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.curator-details-search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0 5px;\n}\n\n.curator-details-search-clear:hover {\n  color: #ef4444;\n}\n\n/* Список студентов для смены старосты */\n.curator-details-students-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.curator-details-student-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-details-student-option:hover {\n  border-color: #002FA7;\n  background: white;\n}\n\n.curator-details-student-option.current {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.curator-details-student-info {\n  flex: 1;\n}\n\n.curator-details-student-name {\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.curator-details-student-details {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.curator-details-current-badge {\n  background: #002FA7;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.curator-details-empty-search {\n  text-align: center;\n  padding: 24px;\n  color: #64748b;\n  font-style: italic;\n}\n\n/* Формы */\n.curator-details-form-group {\n  margin-bottom: 16px;\n}\n\n.curator-details-form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.curator-details-input,\n.curator-details-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.curator-details-input:focus,\n.curator-details-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.readonly-value {\n  padding: 8px 12px;\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.curator-details-form-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #64748b;\n}\n\n/* Кнопки модальных окон */\n.curator-details-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 0 0 12px 12px;\n}\n\n.button-secondary {\n  padding: 8px 16px;\n  background: white;\n  color: #1e293b;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.button-secondary:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.button-primary {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.button-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n/* Информационная иконка */\n.info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.info-icon-text {\n  font-weight: 700;\n  font-size: 16px;\n  color: #002FA7;\n}\n\n.info-icon-btn:hover .info-tooltip,\n.info-icon-btn:focus-within .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(10px);\n  background: white;\n  border: 2px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 320px;\n  max-width: calc(100vw - 40px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.info-tooltip-content {\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.info-section {\n  margin-top: 16px;\n}\n\n.info-section h4 {\n  margin: 0 0 12px 0;\n  color: #002FA7;\n  font-size: 14px;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.usage-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.steps {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.steps-number {\n  width: 24px;\n  height: 24px;\n  background: #002FA7;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.header-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 10px 20px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  height: 44px;\n}\n\n.header-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.pc-refresh-icon {\n  width: 18px;\n  height: 18px;\n  transition: transform 0.3s ease;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.curator-details-modal.social-data-modal {\n  max-width: 900px;\n  width: 92%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.two-columns-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  padding: 0 4px;\n}\n\n.form-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.social-categories-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 450px;\n  overflow-y: auto;\n  padding-right: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.social-category-item {\n  background: #f0f4ff;\n  border: 1px solid #d0d9ff;\n  border-radius: 10px;\n  padding: 12px;\n  transition: all 0.2s ease;\n}\n\n.social-category-item.selected {\n  background: #e8eeff;\n  border-color: #002FA7;\n}\n\n.social-category-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.social-category-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  padding: 0;\n  flex-shrink: 0;\n  accent-color: #002FA7;\n  cursor: pointer;\n  position: relative;\n  top: 3px;\n  margin-right: 10px;\n}\n\n.social-category-name {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.extra-fields {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px dashed #d0d9ff;\n}\n\n.extra-field {\n  margin-bottom: 10px;\n}\n\n.extra-field:last-child {\n  margin-bottom: 0;\n}\n\n.extra-field label {\n  font-size: 12px;\n  color: #475569;\n  margin-bottom: 4px;\n  display: block;\n}\n\n/* Подсказка в социальном портрете */\n.social-portrait-hint {\n  margin-top: 20px;\n  padding: 14px 18px;\n  border-left: 4px solid #002FA7;\n  border-radius: 10px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.hint-text {\n  font-size: 13px;\n  color: #002FA7;\n  line-height: 1.5;\n}\n\n.hint-text strong {\n  color: #002FA7;\n}\n\n/* Стили для степпера социального портрета */\n.social-portrait-stepper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.stepper-header {\n  padding: 16px 20px 12px;\n  border-bottom: 2px solid #e2e8f0;\n  flex-shrink: 0;\n  background: white;\n}\n\n.stepper-steps {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin: 0 15px;\n}\n\n.stepper-steps::before {\n  content: '';\n  position: absolute;\n  top: 18px;\n  left: 35px;\n  right: 35px;\n  height: 2px;\n  background: #e2e8f0;\n  z-index: 1;\n}\n\n.step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n  flex: 1;\n}\n\n.step .step-number {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #64748b;\n  margin-bottom: 6px;\n  transition: all 0.3s;\n  font-size: 14px;\n}\n\n.step.active .step-number {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-color: #002FA7;\n  color: white;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n}\n\n.step-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  text-align: center;\n  max-width: 90px;\n}\n\n.step.active .step-label {\n  color: #002FA7;\n}\n\n.stepper-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n/* Категории в шаге 1 */\n.categories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 8px;\n}\n\n.category-card {\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.category-card:hover {\n  border-color: #002FA7;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.category-card.selected {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.03);\n}\n\n.category-card-content {\n  flex: 1;\n}\n\n.category-card-content h5 {\n  color: #1e293b;\n  font-size: 13px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.category-card-check {\n  width: 24px;\n  height: 24px;\n  background: #002FA7;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n}\n\n/* Двухколоночный макет для шага 2 */\n.two-column-layout {\n  display: flex;\n  gap: 20px;\n  height: 400px;\n  overflow: hidden;\n}\n\n.categories-sidebar {\n  width: 250px;\n  flex-shrink: 0;\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 12px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n}\n\n.categories-sidebar h4 {\n  margin: 0 0 12px 0;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 600;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.categories-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.category-sidebar-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.category-sidebar-item:hover {\n  border-color: #002FA7;\n  transform: translateX(2px);\n}\n\n.category-sidebar-item.active {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.05);\n  border-left-width: 3px;\n}\n\n.category-sidebar-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.category-sidebar-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 12px;\n}\n\n.students-sidebar {\n  flex: 1;\n  background: white;\n  border-radius: 10px;\n  padding: 12px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n\n.current-category-header {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.current-category-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.students-selection-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.selection-controls {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.search-student {\n  flex: 1;\n  position: relative;\n}\n\n.search-student input {\n  width: 100%;\n  padding: 8px 8px 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  height: 34px;\n  box-sizing: border-box;\n}\n\n.search-student input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.search-clear {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #94a3b8;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.btn-select-all {\n  padding: 0 10px;\n  height: 34px;\n  background: white;\n  color: #475569;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-select-all:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.students-list {\n  max-height: 160px;\n  overflow-y: auto;\n  padding: 6px;\n  background: #f8fafc;\n  border-radius: 6px;\n}\n\n.students-list.full-height {\n  flex: 1;\n  max-height: none;\n}\n\n.student-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: white;\n  border-radius: 6px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n}\n\n.student-checkbox:last-child {\n  margin-bottom: 0;\n}\n\n.student-checkbox:hover {\n  border-color: #002FA7;\n}\n\n.student-checkbox.checked {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.student-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.student-checkbox .checkbox-custom {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 4px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.student-checkbox.checked .checkbox-custom {\n  background: #002FA7;\n  border-color: #002FA7;\n  position: relative;\n}\n\n.student-checkbox.checked .checkbox-custom::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 10px;\n}\n\n.student-name {\n  flex: 1;\n  color: #1e293b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.no-results {\n  text-align: center;\n  padding: 16px;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.stepper-footer {\n  flex-shrink: 0;\n  padding: 12px 20px 16px;\n  border-top: 2px solid #e2e8f0;\n  background: white;\n  border-radius: 0 0 12px 12px;\n}\n\n.stepper-progress {\n  margin-bottom: 12px;\n}\n\n.stepper-progress .progress-bar {\n  height: 5px;\n  background: #f8fafc;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.stepper-progress .progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #002FA7, #5986f7);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.stepper-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .two-column-layout {\n    flex-direction: column;\n    height: auto;\n  }\n  \n  .categories-sidebar {\n    width: 100%;\n    max-height: 200px;\n  }\n  \n  .selection-controls {\n    flex-direction: column;\n  }\n  \n  .btn-select-all {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-details-monitor-meta {\n    flex-direction: column;\n  }\n  \n  .curator-details-monitor-name {\n    min-width: auto;\n  }\n  \n  .stepper-steps::before {\n    display: none;\n  }\n  \n  .step {\n    flex-direction: row;\n    gap: 12px;\n  }\n  \n  .step .step-number {\n    margin-bottom: 0;\n  }\n  \n  .step-label {\n    text-align: left;\n    max-width: none;\n  }\n  \n  .categories-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .curator-details-table {\n    min-width: 500px;\n  }\n  \n  .curator-details-col-name {\n    max-width: 150px;\n    min-width: 120px;\n  }\n}\n\n.social-categories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.social-categories-grid.large {\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n/* Карточка социальной категории */\n.social-category-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.social-category-card:hover {\n  border-color: #002FA7;\n  background: #f0f4ff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.social-category-card.selected {\n  border-color: #002FA7;\n  background: linear-gradient(135deg, rgba(0, 47, 167, 0.05), rgba(89, 134, 247, 0.05));\n}\n\n/* Чекбокс для категории */\n.category-checkbox,\n.category-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  border: 2px solid #cbd5e1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  background: white;\n}\n\n.social-category-card.selected .category-checkbox,\n.social-category-card.selected .category-icon {\n  background: #002FA7;\n  border-color: #002FA7;\n  color: white;\n}\n\n.category-checkbox span,\n.category-icon span {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.category-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e293b;\n  flex: 1;\n}\n\n.category-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.curator-details-student-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-details-student-option:hover {\n  border-color: #002FA7;\n  background: white;\n  transform: translateX(4px);\n}\n\n.curator-details-student-option.selected {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.curator-details-student-checkbox {\n  flex-shrink: 0;\n}\n\n.checkbox-custom {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #cbd5e1;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.checkbox-custom.checked {\n  background: #002FA7;\n  border-color: #002FA7;\n  color: white;\n}\n\n.checkbox-custom.checked span {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.readonly-value {\n  padding: 10px 12px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 14px;\n  cursor: not-allowed;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n\n.curator-details-monitor-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 14px;\n  color: #4f5b66;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.curator-details-monitor-meta span {\n  color: #3a4b63;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  background: #f8fafc;\n  padding: 8px 16px;\n  border-radius: 30px;\n  border: 1px solid #e9ecf0;\n  transition: all 0.2s ease;\n}\n\n.curator-details-monitor-meta span:hover {\n  background: #f0f4ff;\n  border-color: #d0d9ff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.08);\n}\n\n.meta-label {\n  color: #64748b;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.curator-details-modal-content {\n  max-height: 70vh;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.curator-details-form-group {\n  margin-bottom: 20px;\n}\n\n.curator-details-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.curator-details-input,\n.curator-details-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.curator-details-input:focus,\n.curator-details-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.curator-details-form-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #64748b;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .social-categories-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .curator-details-monitor-info {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .curator-details-monitor-meta {\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .curator-details-monitor-meta span {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-details-modal {\n    width: 95%;\n    margin: 16px;\n  }\n}\n\n/* Стили для 1 шага социального портрета */\n.social-portrait-step1 {\n  animation: fadeInUp 0.4s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.categories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.category-card {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.category-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #002FA7, #5986f7);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.category-card:hover {\n  border-color: #002FA7;\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 47, 167, 0.15);\n}\n\n.category-card:hover::before {\n  opacity: 1;\n}\n\n.category-card.selected {\n  border-color: #002FA7;\n  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03), rgba(89, 134, 247, 0.03));\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 47, 167, 0.12);\n}\n\n.category-card-content {\n  flex: 1;\n}\n\n.category-card-content h5 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  transition: color 0.2s ease;\n}\n\n.category-card.selected .category-card-content h5 {\n  color: #002FA7;\n}\n\n.category-card-description {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.category-card-check {\n  width: 28px;\n  height: 28px;\n  background: white;\n  border: 2px solid #cbd5e1;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.category-card.selected .category-card-check {\n  background: #002FA7;\n  border-color: #002FA7;\n  transform: scale(1.1);\n}\n\n.category-card-check span {\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Анимация для выбранных карточек */\n@keyframes selectPop {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.category-card.selected {\n  animation: selectPop 0.3s ease-out;\n}\n\n/* Шапка степпера с улучшенным дизайном */\n.stepper-header {\n  padding: 20px 24px 16px;\n  border-bottom: 2px solid #e2e8f0;\n  flex-shrink: 0;\n  background: linear-gradient(to bottom, #ffffff, #fafbfc);\n}\n\n.stepper-steps {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin: 0 20px;\n}\n\n.stepper-steps::before {\n  content: '';\n  position: absolute;\n  top: 18px;\n  left: 50px;\n  right: 50px;\n  height: 3px;\n  background: linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%);\n  z-index: 1;\n  border-radius: 3px;\n}\n\n.step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n  flex: 1;\n  cursor: default;\n}\n\n.step .step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: white;\n  border: 3px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #64748b;\n  margin-bottom: 8px;\n  transition: all 0.3s ease;\n  font-size: 16px;\n  position: relative;\n  z-index: 2;\n}\n\n.step.active .step-number {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-color: #002FA7;\n  color: white;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);\n  transform: scale(1.05);\n}\n\n.step.completed .step-number {\n  background: #10b981;\n  border-color: #10b981;\n  color: white;\n}\n\n.step.completed .step-number::after {\n  content: '✓';\n  font-size: 14px;\n}\n\n.step-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  text-align: center;\n  max-width: 120px;\n  letter-spacing: 0.3px;\n}\n\n.step.active .step-label {\n  color: #002FA7;\n  font-weight: 700;\n}\n\n/* Мультистрочное отображение старост */\n.curator-headman-value {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.curator-monitor-name-line {\n  font-size: 14px;\n  color: #1e293b;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.curator-detail-value-multiline {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.curator-detail-value-multiline div {\n  font-size: 13px;\n  color: #002FA7;\n  font-weight: 600;\n}\n\n/* Стили для выбора нескольких старост */\n.curator-details-selection-info {\n  margin: 0 0 12px 0;\n  padding: 8px 14px;\n  background: #f8fafc;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.selection-count {\n  font-size: 13px;\n  color: #475569;\n}\n\n.selection-count strong {\n  color: #002FA7;\n  font-size: 16px;\n}\n\n.clear-selection-btn {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.clear-selection-btn:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.curator-details-student-option.selected {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.curator-details-student-checkbox {\n  flex-shrink: 0;\n}\n\n.checkbox-custom {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #cbd5e1;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  background: white;\n  cursor: pointer;\n}\n\n.checkbox-custom.checked {\n  background: #002FA7;\n  border-color: #002FA7;\n}\n\n.checkbox-custom.checked span {\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.curator-details-student-option .curator-details-student-info {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
